import React from "react";

const MatchScoreDisplay: React.FC<{
  goal1: number;
  goal2?: number;
  className: string;
  style?: React.CSSProperties;
}> = ({ goal1, goal2, className, style }) => (
  <div>
    <span className={className} style={style}>
      {goal1 + (goal2 !== undefined ? ` - ${goal2}` : "")}
    </span>
  </div>
);

export default MatchScoreDisplay;
